import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import { __, formatPrice, formatPercents } from '../../../../Utils';
import { connect } from '../../../../Store';
import BaseList from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

class ProductItems extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Riadky faktúry'),
      notFoundMessage: __('Ľutujeme riadky sa nenašli'),
      isProduct: true,
      showFilter: false,
      showHeader: false,
      sorter: 'line_no',
      displayedColumns: {},
      buttonsSwitch: [],
      defaultFilter: [
        {
          id: 'type',
          values: ['invoices'],
        },
      ],
    };
  }

  componentDidMount() {
    this.init();
  }

  init() {
    const {
      actualPage,

      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    let newCheckedFilter = [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        loading: true,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(
          !newCheckedFilter || newCheckedFilter.length === 0,
        );
        await this.fetchData();
        this.setTableHeight();
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText, sorter } = this.state;
      this.setState({ loading: true, showProductAddedPopup: false });
      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      params.sorter = sorter;

      const newData = await API2.getB2BInvoiceRowsAction(this.props.id, params);
      this.setState({
        tableItems: newData.items,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.log(e);
      this.setState({ error: __('Nepodarilo sa načítať riadky faktúry') });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;
    switch (s) {
      case '_id':
        if (sorter === 'line_no') {
          newSorter = '-line_no';
        } else {
          newSorter = 'line_no';
        }
        break;
      case 'description':
        if (sorter === 'description') {
          newSorter = '-description';
        } else {
          newSorter = 'description';
        }
        break;
      case 'CENA':
        if (sorter === 'Price') {
          newSorter = '-Price';
        } else {
          newSorter = 'Price';
        }
        break;
      default:
        newSorter = '';
        break;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  setTableHeight() {
    if (this.pager && this.mainWrapper && this.segment) {
      const tableHeight = window.innerHeight - 600;

      this.setState({ tableHeight });
    }
  }

  createColumns(sorter) {
    const result = [
      {
        accessor: '_id',
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('_id')}
            sorter={
              sorter === 'line_no' || sorter === '-line_no' ? sorter : null
            }
          >
            {__('Číslo')}
          </IconTd>
        ),
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'description',
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('description')}
            sorter={
              sorter === 'description' || sorter === '-description'
                ? sorter
                : null
            }
          >
            {__('Popis')}
          </IconTd>
        ),
        minWidth: 200,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'quantity',
        Header: () => <IconTd>{__('Množstvo')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'unit_of_measure',
        Header: () => <IconTd>{__('MJ')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'unit_price',
        Header: () => <IconTd>{__('Cena za ks')}</IconTd>,
        Cell: props => {
          return <P>{formatPrice(props.value)}</P>;
        },
      },
      {
        accessor: 'line_discount',
        Header: () => <IconTd>{__('Zľava %')}</IconTd>,
        Cell: props => {
          return <P>{formatPercents(props.value)}</P>;
        },
      },
      {
        accessor: 'price',
        Header: () => <IconTd>{__('Cena za ks po zľave')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatPrice({
                currency: props.value.currency,
                amount: props.value.amount / props.original.quantity,
              })}
            </P>
          );
        },
      },
      {
        accessor: 'price',
        Header: () => <IconTd>{__('Čiastka')}</IconTd>,
        Cell: props => {
          return <P>{formatPrice(props.value)}</P>;
        },
      },
    ];

    return result;
  }

  render() {
    return super.render();
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ProductItems);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Invoices/Rows/index.jsx